import { PricingTierId, PricingTierResponse } from '@business/entities/order';
import { Endpoint } from '../endpoint';

export function fetchTiers() {
  return Endpoint.get<PricingTierResponse[]>(`@gc/tiers`);
}

export function createTier(data: Partial<PricingTierResponse>) {
  return Endpoint.post<PricingTierResponse>(`@gc/tiers`, { data });
}

export function updateTier(id: PricingTierId, data: Partial<PricingTierResponse>) {
  return Endpoint.patch<PricingTierResponse>(`@gc/tiers/${id}`, { data });
}

export function deleteTier(id: PricingTierId) {
  return Endpoint.delete<void>(`@gc/tiers/${id}`);
}

export function makeDefault(id: PricingTierId) {
  return Endpoint.post<PricingTierResponse[]>(`@gc/tiers/make-default/${id}`);
}
